export const MANAGE_TESTS = 'Manage Tests';
export const MANAGE_USERS = 'Manage Users';
export const REPORT_MANAGEMENT = 'Report Management';
export const MANAGE_COMPANIES = 'Manage Companies';
export const DASHBOARD = 'Dashboard';
export const LAYOUT_MANAGEMENT = 'Layout Management';

export const PAGE_PATHS = {
  [MANAGE_TESTS]: {
    name: MANAGE_TESTS,
    link: '/tests',
  },
  [MANAGE_USERS]: {
    name: MANAGE_USERS,
    link: '/users',
  },
  [REPORT_MANAGEMENT]: {
    name: REPORT_MANAGEMENT,
    link: '/reports',
  },
  [MANAGE_COMPANIES]: {
    name: MANAGE_COMPANIES,
    link: '/companies',
  },
  [DASHBOARD]: {
    name: DASHBOARD,
    link: '/dashboard',
  },
  [LAYOUT_MANAGEMENT]: {
    name: LAYOUT_MANAGEMENT,
    link: '/layouts',
  },
};



// WEBPACK FOOTER //
// src/constants/pathsRoots.js